(function ($) {
    //$.fn.initializeSwiper = function (options) {
    $.fn.initializeSwiper = function () {
        //var defaults = {}
        //var settings = $.extend(defaults, options);
        var swiperIndex = 1;
        
        //function definitions:
        function _init(self, swiperIndex) {
            
            var $slider = self;
            var swiperClass = 'swiper-container-js-' + swiperIndex;
            var swiperSelector = '.'+swiperClass;
			var swiperContainerSelector = swiperSelector + ' ' + ' .swiper-container';
            //var totalSlides = $slider.data('totalslides');
            //var isCarousel = $slider.data('iscarousel');
            //var directionSwiper = $slider.data('pagination-direction');
            //var nbSlidesSwiper = $slider.data('slidesperview');
            //var nbSlidesGroupSwiper = $slider.data('slidespergroup');
            
            //var windowWidth = $(window).width();
           //var documentWidth = $(document).width();
            
            $slider.addClass(swiperClass);

            var optionsSwiper = {
				navigation: {
					nextEl: swiperSelector+' .swiper-button-next',
					prevEl: swiperSelector+' .swiper-button-prev',
				},
				pagination: {
					el: swiperSelector+' .swiper-pagination',
					clickable: true,
				},
				effect: 'fade',
                paginationClickable: true,
                speed: 850,
				loop:true,
				spaceBetween: 0,
			};

			if($slider.hasClass('swiper-container-js-group')){

				var countSlide = $slider.find(".swiper-slide");
				if(countSlide.length < 4){
					$slider.addClass('variant-less-4');
				}

				optionsSwiper = {
					slidesPerView: 4,
					spaceBetween: 0,
					slidesPerGroup: 1,
					loop: true,
					navigation: {
						nextEl: swiperSelector+' .swiper-button-next',
						prevEl: swiperSelector+' .swiper-button-prev',
					},
					breakpoints: {
						750: {
							slidesPerView: 2
						},
						1200: {
							slidesPerView: 3
						}
					},
				};
			}

            /*if($slider.hasClass('swiper-container-autofade')){
                optionsSwiper.autoplay = 4000;
                optionsSwiper.autoplayDisableOnInteraction = false;
                optionsSwiper.effect = 'fade';
            }
                        
            if(directionSwiper && directionSwiper.length > 0){
                optionsSwiper.direction = directionSwiper;
            }

            if(nbSlidesSwiper && nbSlidesSwiper > 0){
                optionsSwiper.slidesPerView = nbSlidesSwiper;
            }

            if(nbSlidesGroupSwiper && nbSlidesGroupSwiper > 0){
                optionsSwiper.slidesPerGroup = nbSlidesGroupSwiper;
            }

            if(!$(swiperSelector).hasClass('container-carousel-large')){
                optionsSwiper.breakpoints = {
                    992: {
                        slidesPerView: 2,
                        slidesPerGroup: 2
                    },
                    650: {
                        slidesPerView: 1,
                        slidesPerGroup: 1
                    }
                };
            }

            if ((totalSlides > 3 && windowWidth >= 992)
                || (totalSlides > 2 && windowWidth > 650 && windowWidth < 992)
                || (totalSlides > 1 && windowWidth <= 650)
                || isCarousel
                ){
                optionsSwiper.loop = true;
                optionsSwiper.paginationType = "bullets";
            }else{
                optionsSwiper.dots = false;
            }*/

			/* eslint-disable-next-line */
			var swiper = new Swiper(swiperContainerSelector, optionsSwiper);
            
            /*if($('.swiper-container').length){
                if($('.swiper-container').hasClass('swiper-container-fade')){
                    var swiper = new Swiper('.swiper-container', {
                        nextButton: '.swiper-button-next',
                        prevButton: '.swiper-button-prev',
                        spaceBetween: 0,
                        loop: true,
                        effect: 'fade'
                    });
                }else{
                    var swiper = new Swiper('.swiper-container', {
                        nextButton: '.swiper-button-next',
                        prevButton: '.swiper-button-prev',
                        spaceBetween: 0,
                        loop: true
                    });
                }
            }*/
            
        }
        
        //iterate
        this.each(function () {
            var self = $(this);
            _init(self, swiperIndex);
            swiperIndex++;
        });

        return this;
            

    };

	//initiate swipers
	$(window).on('load', function(){
		if($(".swiper-container-js").length){
			$(".swiper-container-js").initializeSwiper();
		}
	});
    
    //on resize
    $(window).resize(function(){
        if($(".swiper-container-js").length){
            $(".swiper-container-js").initializeSwiper();
        }
    });
    
})(jQuery);


// WEBPACK FOOTER //
// ./scripts/modules/swiper.js